// extracted by mini-css-extract-plugin
module.exports = {"wish":"WishButton_wish__T-G7q","noBackground":"WishButton_noBackground__2zkCG","wished":"WishButton_wished__i_JeX","inDesktop":"WishButton_inDesktop__3fhSP"};